import React, { useEffect, useState } from 'react'
import { recruiterProfileDetails } from '../../action/profile';
import Loader from '../../Component/Common/Loader';
import ViewComponent from '../../Component/CompanyProfile/View'
const ViewProfile = () => {
    const [data, setData] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    useEffect(() => {
        recruiterProfileDetails().then((res) => {
            if (res.status) {
                setData(res.result)
            }
        }).finally(() => {
            setShowLoader(false)
        });
    }, [])
    return (
        <React.Fragment>
            {showLoader && <Loader />}

            {data && <ViewComponent
                data={data}
            />}

        </React.Fragment>
    )
}

export default ViewProfile